import React, { useState } from "react";
import { Layout, Menu, Breadcrumb } from "antd";
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

const { Content, Sider } = Layout;

const graphs = [
  {
    id: "graph1",
    title: "Evolución en el tiempo",
    menuTitle: "Evolución en el tiempo",
    text: `En 2024, un 22% de las niñas y los niños vive en barrios con una alta acumulación de basura. Esta proporción se ha mantenido estable desde 
          el 2015.`,
    link: "https://public.flourish.studio/visualisation/20935942/embed",
  },
  {
    id: "graph2",
    title: "Análisis por sexo",
    menuTitle: "\u2022 Sexo",
    text: `No hay diferencias por sexo en la proporción de niñas y niños que viven en barrios con una alta acumulación de basura, para ningún año de 
          medición.`,
    link: "https://public.flourish.studio/visualisation/20935947/embed",
  },
  {
    id: "graph3",
    title: "Análisis por edad",
    menuTitle: "\u2022 Edad",
    text: `Si bien entre 2015 y 2022 no hubo diferencias por edad en la  proporción de niñas y niños que viven en barrios con una alta acumulación de 
          basura, en 2024 se observa una mejora para la Infancia media. Mientras que en 2024 este grupo muestra un descenso de 3 puntos porcentuales 
          que rompen la estabilidad histórica, los otros dos grupos no muestran diferencias estadísticamente significativas con respecto al 2022.`,
    link: "https://public.flourish.studio/visualisation/23449305/embed",
  },
  {
    id: "graph4",
    title: "Análisis por país de nacimiento",
    menuTitle: "\u2022 País de nacimiento",
    text: `No hay diferencias según el país de nacimiento de las niñas y los niños: alrededor de un 21% tanto de las niñas y los niños que nacieron en 
          el país como aquellos que nacieron en otros países viven en barrios con acumulación de basura.`,
    link: "https://public.flourish.studio/visualisation/20935959/embed", 
  },
  {
    id: "graph5",
    title: "Análisis por pueblo originario",
    menuTitle: "\u2022 Pueblo originario",
    text: `Desde 2022, las niñas y los niños que se identifican con un pueblo originario viven en barrios con acumulación de basura en mayor medida 
          que aquellos que no se identifican, tendencia que se mantiene al 2024. En 2015 y 2017 las diferencias entre ambos grupos no son significativas.`,
    link: "https://public.flourish.studio/visualisation/23489885/embed", 
  },
  {
    id: "graph6",
    title: "Análisis por quintil de ingresos",
    menuTitle: "\u2022 Quintil de ingresos",
    text: `En toda la serie de tiempo se mantiene una tendencia constante: la exposición a la acumulación de basura en los barrios está fuertemente 
          condicionada por el nivel de ingresos. En 2024, casi una cuarta parte de las niñas y niños pertenecientes a los dos primeros quintiles residen 
          en entornos con alta presencia de residuos (25% y 23% respectivamente), cifras que prácticamente no han mostrado variaciones significativas 
          en la última década.

  Si bien a partir del tercer quintil se observa una disminución progresiva, el descenso más pronunciado ocurre en los estratos de mayores ingresos, 
          quienes además han liderado la mejora del indicador en los últimos dos años. De hecho, en el quinto quintil la prevalencia es del 14%, cifra 
          que representa casi la mitad de lo registrado en los sectores más vulnerables (Quintil I). Esta brecha evidencia que los sectores medios y 
          altos están menos expuestos a basura, que los sectores de menores ingresos.`,
    link: "https://public.flourish.studio/visualisation/28043731/embed",
  },
  {
    id: "graph7",
    title: "Análisis por zona de residencia",
    menuTitle: "\u2022 Zona",
    text: `Las niñas y los niños que residen en zonas urbanas viven con presencia de basura en sus barrios en mayor medida que aquellos que viven en 
          zonas rurales. La proporción en los primeros es más que el doble que en los segundos (23% y 10%, respectivamente) Esta diferencia se ha 
          mantenido muy similar en todos los años de la medición.`,
    link: "https://public.flourish.studio/visualisation/23449423/embed",
  },
  {
    id: "graph8",
    title: "Análisis por macrozona",
    menuTitle: "\u2022 Macrozona",
    text: `En 2024, en la macrozona Metropolitana, un 29% de las niñas y los niños vive en barrios con alta presencia de basura. La macrozona Norte es 
          la segunda que más tiene niñas y niños en esta situación con un 24%. La zona centro y sur son las que menos acumulación de basura tienen en 
          sus barrios, con alrededor de un 14%.`,
    link: "https://public.flourish.studio/visualisation/23489923/embed",
  },
  {
    id: "graph9",
    title: "Análisis por región",
    menuTitle: "\u2022 Región",
    text: `Las regiones presentan una gran variación respecto a la proporción de niñas y niños viviendo en zonas con una alta acumulación de basura. 
          Dentro de las regiones que presentan una mayor proporción en 2024, se consolidan Tarapacá (37%), que muestra un empeoramiento respecto a la 
          medición anterior, Arica y Parinacota (31%) y la Región Metropolitana (29%), que se mantiene como el tercer foco más crítico del país. Por 
          otro lado, las regiones con una menor proporción de niñez afectada son Magallanes (7%), la región de Los Ríos (10%) y las regiones del Maule y 
          Ñuble (ambas con un 10%).

  Respecto al 2022, solo se observa una disminución en la proporción de niñas y niños con una alta exposición a basura en sus barrios en las regiones 
        de Aysén, siendo la más drástica, de 23% al 13% en 2024, en La Araucanía, del 18% al 12%, y Los Ríos, del 15% al 10%.`,
    link: "https://public.flourish.studio/visualisation/20935943/embed",
  }
];

const App = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [selectedMenuItem, setSelectedMenuItem] = useState("graph1");

  const handleMenuItemClick = (graphId) => {
    setSelectedMenuItem(graphId);
  };

  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
  };

  const selectedGraph = graphs.find((graph) => graph.id === selectedMenuItem);

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sider
        width={250}
        collapsible
        collapsed={collapsed}
        onCollapse={toggleCollapsed}
        style={{ background: "#fff" }}
        breakpoint="lg"
        collapsedWidth={0}
      >
        <Menu
          theme="dark"
          mode="vertical"
          selectedKeys={[selectedMenuItem]}
          style={{ background: "#fff" }}
        >
          {graphs.map((graph) => (
            <Menu.Item
              key={graph.id}
              onClick={() => handleMenuItemClick(graph.id)}
              style={{
                color: "black",
                paddingLeft: graph.id !== "graph1" ? "30px" : "20px",
              }}
            >
              {graph.menuTitle}
            </Menu.Item>
          ))}
        </Menu>
      </Sider>
      <Layout style={{ padding: "24px 24px 24px" }}>
        <Breadcrumb style={{ margin: "16px 0" }}>
          <Breadcrumb.Item></Breadcrumb.Item>
        </Breadcrumb>
        <Content
          id="content"
          style={{
            background: "#ffff",
            padding: 24,
            margin: 0,
            minHeight: 280,
          }}
        >
          {selectedGraph && (
            <div>
              <div style={{ marginBottom: 16 }}>
                <h1>{selectedGraph.title}</h1>
              </div>
              <div style={{ textAlign: 'justify' }}>
                <ReactMarkdown remarkPlugins={[remarkGfm]}>
                  {selectedGraph.text}
                </ReactMarkdown>
              </div>
              {selectedGraph.link && (
                <iframe
                  src={selectedGraph.link}
                  frameBorder="0"
                  scrolling="no"
                  style={{ minWidth: "100%", height: "500px" }}
                ></iframe>
              )}
            </div>
          )}
        </Content>
      </Layout>
    </Layout>
  );
};

export default App;